import CoreBase from '../../../../services/engines/CoreBase';
import userTopicService from '../../../../services/UserTopicService';

/**
 * Fetches search results from the API.
 * No cache, no state, no side effects beyond the HTTP call.
 * Returns result data on success, null on failure.
 * Not a singleton — instantiated by SearchEngine (see Development.Patterns, ServiceAgent Pattern).
 */
class SearchFetcher extends CoreBase {
    // Class field — overrides CoreBase._name so logError shows correct source
    _name = 'SearchFetcher';

    /**
     * Executes a search query against the API.
     * @param {string} query - Search term, min 3 chars
     * @param {number} page - Page number to fetch
     * @param {number} size - Page size
     * @returns {object|null} { items, total, page } or null on failure
     */
    search = async (query, page, size) => {
        try {
            const rk = 'default';
            const topic = '';
            const resp = await userTopicService.search({ rk, q: query, topic, page, size });
            if (resp === -1) return null;

            return {
                total: resp.data?.totalItems ?? 0,
                items: resp.data?.items ?? [],
                page: resp.data?.page ?? 1,
            };
        } catch (error) {
            this.logError('search', error.message);
            return null;
        }
    };
}

const searchFetcher = new SearchFetcher();
export default searchFetcher;
